module.exports = __webpack_public_path__ + "front/img/login-kv.7e32c5e2.png";